import { Component, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import * as _ from 'lodash';

import { Option } from 'shared/form/select/option.interface';
import { createOption } from 'shared/form/select/option-helpers';

import { BrandService } from 'shared/brand/brand.service';
import { PriceSheetService } from 'shared/price-sheet/price-sheet.service';
import { takeWhile } from 'rxjs/operators';


@Component({
  moduleId: module.id,
  selector: 'export-price-sheet-options',
  templateUrl: 'export-price-sheet-options.component.html',
  styleUrls: ['export-price-sheet-options.component.scss'],
})
export class ExportPriceSheetOptionsComponent implements OnDestroy {
  @Input() status: string;

  priceSheetsList: Array<Option> = [];
  priceSheets: Array<any> = [];
  private isActive: boolean = true;

  constructor(
    protected brandService: BrandService,
    protected priceSheetService: PriceSheetService,
    protected ref: ChangeDetectorRef,
  ) {}

  /*******************************************
  * COMPONENT GETTERS
  *******************************************/

  get selectedPrices(): Array<string|number> {
    return this.getSelectedOptions(this.priceSheetsList);
  }

  get selectedCurrencies(): Array<string|number> {
    const currencies = _.chain(this.priceSheets)
      .filter(price => this.selectedPrices.includes(price.price_sheet_number))
      .map((priceSheet: any) => {
        if (!_.isArray(priceSheet.currency_code)) {
          return [priceSheet.currency_code];
        } else {
          return priceSheet.currency_code;
        }
      })
      .flatten()
      .value();
    return currencies;
  }

  get allSelectedData(): any {
    return {
      priceSheets: this.selectedPrices,
    };
  }

  get brandId(): any {
    return this.brandService.getBrand();
  }

  getPriceSheetCurrenciesList(): Array<Option> {
    return _.chain(this.priceSheets)
      .sortBy('default')
      .map((priceSheet: any) => {
        if (!_.isArray(priceSheet.currency_code)) {
          return [priceSheet.currency_code];
        } else {
          return priceSheet.currency_code;
        }
      })
      .flatten()
      .uniq()
      .map((currency: any) => {
        const isSelected = this.selectedCurrencies.includes(currency);

        const option = {
          option: currency,
          title: currency,
          selected: isSelected,
          hidden: false,
        };
        return option;
      })
      .value();
  }

  ngOnDestroy() {
    this.isActive = false;
  }

  /*******************************************
  * COMPONENT PUBLIC
  *******************************************/

  public getLists(): void {
    this.priceSheetService.fetchAll(this.brandId)
    .pipe(takeWhile(() => this.isActive))
    .subscribe((result: Array<Array<Option>>) => {
      this.priceSheetsList = _.chain(result)
      .sortBy('default')
      .map((priceSheet: any) => {
        const option = createOption(priceSheet.price_sheet_number, priceSheet.price_sheet_name);
        // preselect primary price sheet
        if (priceSheet.default === 1) {
          option.selected = true;
          option.title = `${option.title} (Primary)`;
        }
        if (priceSheet.default === 2) {
          option.title = `${option.title} (Secondary)`;
        }
        return option;
      }).value();
      this.priceSheets = result;
      this.ref.markForCheck();
    });
  }

  public reset(): void {
    this.priceSheetsList = [];
  }

  /*******************************************
  * COMPONENT PROTECTED
  *******************************************/

  protected getSelectedOptions(formatsList: Array<Option>): Array<number|string> {
    return _.chain(formatsList)
    .filter(['selected', true])
    .map('option')
    .value();
  }

}
